import { useMemo } from "react";

import { useTypedSelector } from "../../redux/store";
import { getConnectionStats } from "../../utils/connectionQuality";

const useConnectionStats = () => {
	const connected = useTypedSelector((state) => state.prpc.connected);
	const online = useTypedSelector((state) => state.connectionQuality.online);
	const samples = useTypedSelector(
		(state) => state.connectionQuality.samples,
	);

	return useMemo(
		() => getConnectionStats({ online, connected, samples }),
		[online, connected, samples],
	);
};

export default useConnectionStats;
